import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {TranslocoService} from "@jsverse/transloco";
import {LocaleService} from "../../../services/mygreencountry/locale.service";
import {LANGUAGES} from "../../constants";
import {ParentService} from "../../../services/mygreencountry/parent.service";

@Component({
    selector: 'app-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent implements OnInit {


    @Input() showListStyle: boolean = false;
    @Input() showBtnStyle: boolean = false;

    @ViewChild('popover') popover: any;

    public activeLanguage: string = LANGUAGES[0]['value']
    public selectedLanguageIcon: string = LANGUAGES[0]['image']
    availableLanguages: any = [];
    isPopoverLangOpen = false;
    // showSwitcher:boolean = false;

    constructor(
        private translocoService: TranslocoService,
        private localService: LocaleService,
        private parentService: ParentService,
    ) {
        let studentId = this.parentService.getActiveChildId();
        // this.showSwitcher = studentId === 12668;
        this.activeLanguage = this.translocoService.getActiveLang() ? this.translocoService.getActiveLang() : "uk";
        this.availableLanguages = this.translocoService.getAvailableLangs();
        this.getSelectedLanguageImage()
    }

    ngOnInit() {

    }

    presentPopover(e: Event) {
        this.popover.event = e;
        this.isPopoverLangOpen = true;
    }


    getSelectedLanguageImage(): any {
        let selectedLang = LANGUAGES.find(lang => lang.value === this.activeLanguage);

        if (selectedLang && selectedLang.image) {
            this.selectedLanguageIcon = selectedLang.image;
        }
    }

    changeLang(selectedLang: string) {
        this.translocoService.setActiveLang(selectedLang);
        this.localService.setLanguage(selectedLang);
        this.activeLanguage = selectedLang;
        this.getSelectedLanguageImage();

        this.isPopoverLangOpen = false

        setTimeout(() => {
            window.location.reload();
        }, 500);
    }

    getLanguageImage(langValue: string): string {
        let selectedLang = LANGUAGES.find(language => language.value === langValue);
        return selectedLang ? selectedLang.image : LANGUAGES[0].image;
    }

    getLanguageText(langValue:string): string {
        let selectedLang = LANGUAGES.find(language => language.value === langValue);
        return selectedLang ? selectedLang.text : LANGUAGES[0].text;
    }

}
